import packageMetadata from '../../package.json';

/** Client-safe application version; never includes credentials or machine paths. */
export const APP_VERSION = packageMetadata.version;
